import { type Ref, ref, watch } from 'vue'

// Mirrors `source`, but only updates the returned ref when `isReady` is true —
// keeps showing the last good value while a refetch is in flight.
export function useStableValue<T>(
  source: Ref<T>,
  isReady: Ref<boolean>,
): Ref<T> {
  const stable = ref(source.value) as Ref<T>
  watch(isReady, (ready) => {
    if (ready) stable.value = source.value
  })

  return stable
}
